import { useState } from 'react';
import { useAuth } from '@/contexts/useAuth';
import { supabase } from '@/utils/supabase';
import { LwField, LwButton } from '@/components/lw';
import { toast } from 'sonner';

export function RecruitEmailAdmin({ recruitId, email, onChanged }: { recruitId:string;email:string;onChanged:(email:string)=>void }) {
  const { user } = useAuth();
  const [editing,setEditing]=useState(false),[nextEmail,setNextEmail]=useState(email),[reason,setReason]=useState(''),[saving,setSaving]=useState(false);
  const [error,setError]=useState('');
  if (!user?.roles?.includes('admin')) {
return <p className="text-sm text-muted-foreground">An administrator can correct the saved email.</p>;
}
  const save=async()=>{
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(nextEmail.trim()) || reason.trim().length<3) {
 setError('Enter a valid email and a reason for the change.');return;
}
    setSaving(true);setError('');
    try {
      const {data,error:failure}=await supabase.functions.invoke('recruit-auth-admin',{body:{action:'change_email',recruit_id:recruitId,email:nextEmail,reason}});
      if(failure || !data?.success) {
throw new Error('Unable to change the saved email. Check your administrator access and try again.');
}
      onChanged(data.recruit.email);setEditing(false);setReason('');toast.success('Saved email changed. Existing codes and sessions are revoked.');
    } catch {
setError('Unable to change the saved email. Please try again.');
} finally {
setSaving(false);
}
  };
  return <section className="mt-3 space-y-3" aria-label="Saved email administration">
    {!editing ? <LwButton variant="sm" onClick={()=>{
setNextEmail(email);setEditing(true);
}}>Change saved email</LwButton> : <>
      <p className="text-sm text-muted-foreground">This immediately ends existing recruitment sessions and invalidates email codes. Signed agreements keep their original email.</p>
      <LwField label="New saved email" htmlFor="recruit-new-email"><input id="recruit-new-email" type="email" maxLength={254} value={nextEmail} disabled={saving} onChange={event=>setNextEmail(event.target.value)} /></LwField>
      <LwField label="Reason for change" htmlFor="recruit-email-reason"><textarea id="recruit-email-reason" maxLength={500} value={reason} disabled={saving} onChange={event=>setReason(event.target.value)} /></LwField>
      <p className="text-xs text-muted-foreground">Describe the correction without including SSN, date of birth, or other personal details.</p>
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      <div className="flex flex-wrap gap-3"><LwButton variant="sm-solid" disabled={saving} onClick={()=>void save()}>{saving?'Saving…':'Save email change'}</LwButton>
        <LwButton variant="sm" disabled={saving} onClick={()=>setEditing(false)}>Cancel</LwButton></div>
    </>}
  </section>;
}
